import { render, staticRenderFns } from "./detailLunbo.vue?vue&type=template&id=2dd0365e&scoped=true"
import script from "./detailLunbo.vue?vue&type=script&lang=js"
export * from "./detailLunbo.vue?vue&type=script&lang=js"
import style0 from "./detailLunbo.vue?vue&type=style&index=0&id=2dd0365e&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/mobile/product-detail.less?vue&type=style&index=1&id=2dd0365e&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd0365e",
  null
  
)

export default component.exports